import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { loadFeatureFlags, useFeatureFlag } from '../stores/featureFlagsStore';

interface RequireFlagProps {
  children: React.ReactElement;
  /** services/feature_flags.py flag name gating this route. */
  flag: string;
  /** Where to send a visitor while the flag is off. Defaults to the app root. */
  redirectTo?: string;
}

/**
 * Route-level guard for a dormancy-switched feature (mirrors RequireTier's
 * shape). The backend already 503s every endpoint behind a disabled flag
 * regardless of this guard -- this exists only so a direct URL visit (or a
 * stale bookmark) lands on a normal redirect instead of a page that renders
 * and then fails every API call it makes. Fails closed like the flag store
 * itself: an unloaded/unknown flag reads false, so this guard defaults to
 * blocking, never to allowing, while flags are still loading.
 */
const RequireFlag: React.FC<RequireFlagProps> = ({ children, flag, redirectTo = '/' }) => {
  useEffect(() => { void loadFeatureFlags(); }, []);
  const enabled = useFeatureFlag(flag);

  if (!enabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default RequireFlag;
